import { render, staticRenderFns } from "./educationPop.vue?vue&type=template&id=0401d093"
import script from "./educationPop.vue?vue&type=script&lang=js"
export * from "./educationPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0401d093')) {
      api.createRecord('0401d093', component.options)
    } else {
      api.reload('0401d093', component.options)
    }
    module.hot.accept("./educationPop.vue?vue&type=template&id=0401d093", function () {
      api.rerender('0401d093', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/edu/result/educationPop.vue"
export default component.exports